import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import AdvisoryScope from './components/AdvisoryScope';
import EngagementProcess from './components/EngagementProcess';
import CounterpartyProfile from './components/CounterpartyProfile';
import Contact from './components/Contact';
import InvestorPortal from './components/InvestorPortal';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/advisory-scope" element={<AdvisoryScope />} />
          <Route path="/engagement-process" element={<EngagementProcess />} />
          <Route path="/counterparty-profile" element={<CounterpartyProfile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/investor-portal" element={<InvestorPortal />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;